module.exports = __webpack_public_path__ + "img/sa-digital-villages.b0912edd.jpg";